// 激发模块
import { getPromptList } from '@/api/prompt'
import { getRandom } from '@/utils/randomNumber'
import { PROMPT_VISITED_LIST, getLocalStorage } from '@/utils/locatonStorge'

const RandomList = getRandom(100)
const LeftRandomList = getRandom(100)
function transformBold(text, keys, latest) {
  for (let i = 0; i < keys.length; i++) {
    text = text.replaceAll(keys[i], `<b class="bold">${keys[i]}</b>`)
  }
  if (latest) {
    return `<div class="prompt-item__latest"></div>${text}`
  }
  return text
}
const Prompt = {
  namespaced: true,

  state: {
    showPromptTab: false, // 是否展示激发模块
    promptList: [], // 提示列表
    end: false
  },
  mutations: {
    SET_SHOW_PROMPT_STATUS: (state, showPromptStatus) => {
      state.showPromptTab = showPromptStatus
    },
    SET_PROMPT_LIST: (state, promptList) => {
      state.promptList = promptList
    }
  },
  getters: {
    // 统一判断
    showH5PromptPanel: (state, _, rootState) => {
      return state.showPromptTab && rootState.Home.isMobile && state.promptList.length > 0
    },
    showPcPromptPanel: (state, _, rootState) => {
      return state.showPromptTab && !rootState.Home.isMobile && state.promptList.length > 0
    },
    showList: state => {
      const visitedList = getLocalStorage(PROMPT_VISITED_LIST, true) || []
      return state.promptList.map((l, index) => {
        l.displayText = transformBold(l.text, l.keyword, l.latest || false)
        if (visitedList.indexOf(l.id) > -1) {
          l.visited = true
        } else {
          l.visited = false
        }
        l.style = RandomList[index]
        return l
      })
    },
    leftList: (_, getters) =>
      getters.showList
        .filter((_, index) => index % 2 === 0)
        .map((l, index) => {
          return {
            ...l,
            style: LeftRandomList[index]
          }
        }),
    rightList: (_, getters) =>
      getters.showList
        .filter((_, index) => index % 2 === 1)
        .concat()
        .map((l, index) => {
          return {
            ...l,
            style: RandomList[index]
          }
        })
  },
  actions: {
    GetPromptList({ commit }) {
      return new Promise((resolve, reject) => {
        getPromptList()
          .then(res => {
            if (res.status === 0) {
            } else {
              reject(res.message || '请求错误')
            }
          })
          .catch(() => {
            commit('SET_PROMPT_LIST', [])
          })
      })
    }
  }
}

export default Prompt
